import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const ClubSanctionPlanListApi = (ID, data) =>
    API.get(`${URL.CLUB_PLAN_SANCTION_LIST}/${ID}`, data)
export const PlanSanctionDetailApi = (ID, data) =>
    API.get(`${URL.PLAN_SANCTION_DETAIL}/${ID}`, data)
